import { render, staticRenderFns } from "./BookingDetailPage.vue?vue&type=template&id=4b4ced7e&scoped=true&"
import script from "./BookingDetailPage.vue?vue&type=script&lang=js&"
export * from "./BookingDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./BookingDetailPage.vue?vue&type=style&index=0&id=4b4ced7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4ced7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b4ced7e')) {
      api.createRecord('4b4ced7e', component.options)
    } else {
      api.reload('4b4ced7e', component.options)
    }
    module.hot.accept("./BookingDetailPage.vue?vue&type=template&id=4b4ced7e&scoped=true&", function () {
      api.rerender('4b4ced7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageChild/BookingDetailPage.vue"
export default component.exports